module.exports = __webpack_public_path__ + "static/media/att.37bea6c1.svg";